var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { Icon, Text, Stack, StackChildren, InlineChildren, } from '@doordash/design-language';
import Loading from '@doordash/component-loading';
import Button from '@doordash/component-button';
import { useToast } from '@doordash/component-toast';
import GroupsList from './groups_list';
import { CreateGroupButtonContainer } from './groups_styles';
import { AdminPageSubpageContentContainer } from '../AdminPage/AdminPageStyles';
import CreateGroupModal from './modals/create_group_modal';
import DeleteGroupModal from './modals/delete_group_modal';
import track from '../../utils/track';
import { useSelector, useDispatch } from 'react-redux';
import { fetchTeamAccountGroups } from './groups_slice';
import { GroupActions } from '../../constants/actions';
import { getStatusForAction, getTeamAccountGroups } from './groups_selector';
import { FetchStatus, INITIAL_FETCH_STATUS } from '../../constants/fetch_status';
import AddMembersToGroupModal, { displayAddGroupMembersSuccessToast, } from '../GroupsMembers/modals/add_members_to_group_modal';
import AdminPageEmptyState from '../admin_page_empty_state';
import { GroupPageTestId } from '../testId';
export var Groups = function (_a) {
    var teamAccountId = _a.teamAccountId;
    var dispatch = useDispatch();
    var displayToast = useToast().displayToast;
    var statusForAction = useSelector(getStatusForAction);
    var groupsList = useSelector(getTeamAccountGroups);
    var _b = __read(React.useState(false), 2), isGroupModalOpen = _b[0], setIsGroupModalOpen = _b[1];
    var _c = __read(React.useState(null), 2), deleteModalProps = _c[0], setDeleteModalProps = _c[1];
    var _d = __read(React.useState(null), 2), editModalProps = _d[0], setEditModalProps = _d[1];
    var fetchGroups = React.useCallback(function () { return dispatch(fetchTeamAccountGroups(teamAccountId)); }, [dispatch, teamAccountId]);
    React.useEffect(function () {
        track('workportal_groups');
        fetchGroups();
    }, [fetchGroups]);
    var isFetchStatusPending = function () {
        var _a;
        return [INITIAL_FETCH_STATUS, FetchStatus.PENDING].includes((_a = statusForAction[GroupActions.FETCH_TEAM_ACCOUNT_GROUPS]) === null || _a === void 0 ? void 0 : _a.status);
    };
    var isFetchStatusError = function () {
        var _a;
        return [FetchStatus.INVALID_STATUS, FetchStatus.REJECTED].includes((_a = statusForAction[GroupActions.FETCH_TEAM_ACCOUNT_GROUPS]) === null || _a === void 0 ? void 0 : _a.status);
    };
    var _e = __read(React.useState(null), 2), selectedGroupToAddMembers = _e[0], setSelectedGroupToAddMembers = _e[1];
    var onCloseModal = React.useCallback(function () { return setSelectedGroupToAddMembers(null); }, [setSelectedGroupToAddMembers]);
    var renderLoadingOrError = function (isError) {
        if (isError) {
            return (React.createElement(AdminPageEmptyState, { icon: React.createElement(Icon, { type: Icon.Types.WarningTriangleLine }), title: "Error loading groups", subtitle: "" }));
        }
        return (React.createElement(Loading, { size: Loading.Sizes.Medium, color: Loading.Colors.SystemGrey30 }));
    };
    var displaySuccessMessage = function (group, options) {
        if (options === void 0) { options = { memberCount: 0 }; }
        displayAddGroupMembersSuccessToast(group, options, displayToast);
    };
    return (React.createElement(AdminPageSubpageContentContainer, null,
        React.createElement(Stack, { size: Stack.Sizes.XLarge },
            React.createElement(InlineChildren, { justifyContent: InlineChildren.Justification.SpaceBetween, alignItems: InlineChildren.Alignment.Center },
                React.createElement(StackChildren, { size: Stack.Sizes.XxxSmall },
                    React.createElement(Text, { color: Text.Colors.TextPrimary, styles: Text.Styles.SectionTitleLarge, weight: Text.Weights.Medium }, "All Groups"),
                    React.createElement(Text, { color: Text.Colors.TextTertiary },
                        groupsList.length,
                        " groups")),
                React.createElement(CreateGroupButtonContainer, null,
                    React.createElement(Button, { type: Button.Types.PrimaryPill, onClick: function () {
                            setIsGroupModalOpen(true);
                            track('workportal_click_create_group');
                        }, "data-testid": GroupPageTestId.CreateNewGroupButton }, "Create New Group"),
                    isGroupModalOpen && (React.createElement(CreateGroupModal, { teamAccountId: teamAccountId, group: editModalProps === null || editModalProps === void 0 ? void 0 : editModalProps.group, onGroupCreated: function () {
                            fetchGroups(); // refresh groups list on create
                        }, onClose: function () {
                            setIsGroupModalOpen(false);
                            setEditModalProps(null);
                        } })),
                    deleteModalProps && (React.createElement(DeleteGroupModal, { group: deleteModalProps.group, onGroupDeleted: function () {
                            fetchGroups(); // refresh groups list on delete
                        }, onClose: function () { return setDeleteModalProps(null); } }))))),
        isFetchStatusPending() || isFetchStatusError() ? (renderLoadingOrError(isFetchStatusError())) : (React.createElement(React.Fragment, null,
            React.createElement(GroupsList, { teamAccountId: teamAccountId, groups: groupsList, onDeleteGroupClick: function (group) { return setDeleteModalProps({ group: group }); }, onEditGroupClick: function (group) {
                    setEditModalProps({ group: group });
                    setIsGroupModalOpen(true);
                }, onAddMembersClick: function (group) { return setSelectedGroupToAddMembers(group); } }),
            React.createElement(AddMembersToGroupModal, { group: selectedGroupToAddMembers, onClose: onCloseModal, onSuccess: displaySuccessMessage })))));
};
export default Groups;
